import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "availability-section" }
const _hoisted_2 = { class: "actions" }
const _hoisted_3 = {
  key: 1,
  class: "no-data"
}

import { ref, onMounted } from 'vue'
import { ElNotification } from 'element-plus'
import {
  createEvCarAvailability,
  getEvCarAvailability,
  deleteEvCarAvailability,
} from '@/api/car-ev-data'
import dayjs from 'dayjs'


export default /*@__PURE__*/_defineComponent({
  __name: 'AvaliabilitySection',
  props: {
    vehicleId: {}
  },
  setup(__props: any) {

const props = __props

const availabilityData = ref<
  Array<{
    id: string
    start_date: string
    end_date: string
    created_at: string
    updated_at: string
  }>
>([])

const newAvailability = ref({
  start_date: '',
  end_date: '',
})

const loadAvailabilities = async () => {
  try {
    const response = await getEvCarAvailability(props.vehicleId)

    if (response.data.data) {
      availabilityData.value = response.data.data.map((item: any) => ({
        id: item.id,
        start_date: item.start_date,
        end_date: item.end_date,
        created_at: item.created_at || '-',
        updated_at: item.updated_at || '-',
      }))
    } else {
      availabilityData.value = []
    }
  } catch (error) {
    console.error('Failed to load availabilities:', error)
    ElNotification({
      title: 'Error',
      message: 'Failed to load availabilities.',
      type: 'error',
    })
  }
}

const addAvailability = async () => {
  try {
    if (!newAvailability.value.start_date || !newAvailability.value.end_date) {
      return ElNotification({
        title: 'Error',
        message: 'Please fill in both dates.',
        type: 'error',
      })
    }

    const formattedData = {
      intervals: [
        {
          start_date: dayjs(newAvailability.value.start_date).format(
            'YYYY-MM-DD'
          ),
          end_date: dayjs(newAvailability.value.end_date).format('YYYY-MM-DD'),
        },
      ],
    }

    await createEvCarAvailability(props.vehicleId, formattedData)
    ElNotification({
      title: 'Success',
      message: 'Availability added successfully.',
      type: 'success',
    })
    newAvailability.value.start_date = ''
    newAvailability.value.end_date = ''
    await loadAvailabilities()
  } catch (error) {
    console.error('Failed to add availability:', error)

    const err = error as any
    if (err.response && err.response.data && err.response.data.message) {
      const serverMessage = err.response.data.message
      const details = err.response.data.details

      let errorMessage = serverMessage
      if (details && details.newInterval && details.existingInterval) {
        errorMessage += `\nNew interval: [${details.newInterval.start_date} - ${details.newInterval.end_date}]\n`
        errorMessage += `Existing interval: [${details.existingInterval.start_date} - ${details.existingInterval.end_date}]`
      }

      ElNotification({
        title: 'Error',
        message: errorMessage,
        type: 'error',
        duration: 8000,
      })
    }

    ElNotification({
      title: 'Error',
      message: 'Failed to add availability.',
      type: 'error',
    })
  }
}

const deleteAvailability = async (index: number, row: any) => {
  try {
    await deleteEvCarAvailability(props.vehicleId, row.id)
    ElNotification({
      title: 'Success',
      message: 'Availability deleted successfully',
      type: 'success',
    })
    await loadAvailabilities()
  } catch (error) {
    console.error('Failed to delete availability:', error)
    ElNotification({
      title: 'Error',
      message: 'Failed to delete availability.',
      type: 'error',
    })
  }
}

onMounted(() => {
  loadAvailabilities()
})

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "box-card",
      shadow: "never"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            model: newAvailability.value,
            ref: "formRef",
            "label-width": "100px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Start Date",
                prop: "start_date"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: newAvailability.value.start_date,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newAvailability.value.start_date) = $event)),
                    type: "date",
                    placeholder: "Select Start Date"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "End Date",
                prop: "end_date"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: newAvailability.value.end_date,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newAvailability.value.end_date) = $event)),
                    type: "date",
                    placeholder: "Select End Date"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: addAvailability
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Add")
                ])),
                _: 1,
                __: [2]
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        (availabilityData.value && availabilityData.value.length)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: availabilityData.value,
              style: {"width":"100%"},
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "#",
                  width: "50",
                  type: "index",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "start_date",
                  label: "Start Date",
                  "min-width": "180"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "end_date",
                  label: "End Date",
                  "min-width": "180"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "created_at",
                  label: "Created At",
                  "min-width": "200"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "updated_at",
                  label: "Updated At",
                  "min-width": "200"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Actions",
                  "min-width": "150",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "small",
                      onClick: ($event: any) => (deleteAvailability(scope.$index, scope.row))
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" Delete ")
                      ])),
                      _: 2,
                      __: [3]
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]))
          : (_openBlock(), _createElementBlock("p", _hoisted_3, "No availability data found"))
      ]),
      _: 1
    })
  ]))
}
}

})